const PAGE_LIMIT = 300;

export function craneDisplayValue(value) {
  if (value == null) return "";
  const text = String(value).trim();
  if (!text || text.toLowerCase() === "null") return "";
  return text;
}

function includesQuery(value, query) {
  return typeof value === "string" && value.toLowerCase().includes(query);
}

function createdAtValue(session) {
  return typeof session?.createdAt === "string" ? session.createdAt : "";
}

export function searchCraneGuageSessions(sessions, query) {
  const normalized = String(query ?? "").trim().toLowerCase();
  if (!normalized) return [];

  return (sessions || [])
    .filter(
      (session) =>
        includesQuery(session?.user_name, normalized) ||
        includesQuery(session?.user_email, normalized),
    )
    .sort((a, b) => createdAtValue(b).localeCompare(createdAtValue(a)));
}

export async function fetchAllCraneGuageSessionPages(fetchPage) {
  const items = [];
  let nextToken;
  const seenTokens = new Set();

  do {
    const page = await fetchPage({ limit: PAGE_LIMIT, nextToken });
    if (Array.isArray(page?.items)) {
      items.push(...page.items.filter(Boolean));
    }

    const token = page?.nextToken || null;
    if (!token || seenTokens.has(token)) {
      nextToken = undefined;
    } else {
      seenTokens.add(token);
      nextToken = token;
    }
  } while (nextToken);

  return items;
}

export function readMeetingUri(body) {
  if (body && typeof body === "object" && !Array.isArray(body)) {
    if (typeof body.meetingUri === "string" && body.meetingUri) {
      return body.meetingUri;
    }
  }

  if (Array.isArray(body) && typeof body[0]?.meetingUri === "string") {
    return body[0].meetingUri;
  }

  return "";
}
